import { createAPList, createComponentSourceData, createTemplateList } from "../utilities/helpers";
import axiosInstance from "./axios";
import { fetchWizardList } from "./WizardService";

// Fetch Access Point Types data
export const fetchAPList = async () => {
  try {
    const response = await axiosInstance.get(`${process.env.VUE_APP_BACK}/accessPoint/types`);
    return response.data
  } catch (error) {
    console.error("Failed to fetch wizards:", error);

    throw error;
  }
};

// Fetch Access Points  Data
export const fetchAPListIMAG = async () => {
  try {
    const response = await axiosInstance.get(`${process.env.VUE_APP_BACK}/accessPoint/resources/${"door"}?all_data=true `);
    return createAPList(response.data?.access_point_type || []);
  } catch (error) {
    console.error("Failed to fetch wizards:", error);

    throw error;
  }
};

// Fetch Template  Data
export const fetchAPTemplateList = async (model) => {

  try {
    const response = await axiosInstance.get(`${process.env.VUE_APP_BACK}/accessPointtemplate?unlimit=true&acu_type=${model}`);

    return createTemplateList(response.data || []);
  } catch (error) {
    console.error("Failed to fetch wizards:", error);

    throw error;
  }
};

// Fetch Template  Data
export const fetchACUById = async (id, model) => {

  try {
    const response = await axiosInstance.get(`${process.env.VUE_APP_BACK}/acu/${id}`);
    const res = await axiosInstance.get(`${process.env.VUE_APP_BACK}/acu/models`);
    const acuDataByModal = res.data.controllers[model];
    return {
      access_points: response.data.access_points || [],
      accessPointData: acuDataByModal,
      acuData: createComponentSourceData(response.data.ext_devices, res.data.expansion_boards)
    };
  } catch (error) {
    console.error("Failed to fetch wizards:", error);

    throw error;
  }
};
